import { GridOptions } from "ag-grid-community";

// https://www.ag-grid.com/javascript-grid-column-definitions/#default-column-definitions
const defaultColumnDefs = {
    headerComponent: "headerWithSortingFilter",
    filter: "customFilter",
    menuTabs: ["filterMenuTab"],
    sortable: true,
    checkboxSelection(params) {
        // show check box if it's first displayed column
        if (!params.columnApi) {
            return false;
        }
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        return displayedColumns[0] === params.column;
    }
};

const columnTypes = {
    // No Filter or Sort menu
    nonSortFilterColumn: {
        headerComponent: "agColumnHeader",
        sortable: false,
        filterActive: false
    },
};

export const defaultGridOptions: GridOptions = {
    // all columns has filter/sort menu by default, unless the properties are overwritten
    defaultColDef: defaultColumnDefs,
    columnTypes,
    rowSelection: "multiple",
    rowHeight: 68,
    domLayout: "autoHeight",
    suppressMovableColumns: true,
    suppressHorizontalScroll: true,
    suppressPropertyNamesCheck: true,
    suppressContextMenu: true,
    suppressPaginationPanel: true,
    //set to true to avoid column removal as the grid scrolls horizontally
    suppressColumnVirtualisation: true,
    // Cache 3 pages (next, current & previous) such that toggling between pages can be faster
    maxBlocksInCache: 3,
    loadingCellRenderer: "customLoadingCellRenderer",
    //copy - manually select the text and use the operating system copy/paste
    enableCellTextSelection: true,
    ensureDomOrder: true
};
